import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

/**
 * Graphe des prérequis bloquants, `{ "<attendu_id>": [prérequis…] }`
 * (`GET /themes/liens-prerequis/`, plan popup-choix-attendu). Un appel par
 * chargement de la page ; en échec, un graphe vide : la popup affiche alors
 * les attendus sans arbre.
 */
export const useLiensPrerequis = () => {
  const { data, isError } = useApi(`${url}themes/liens-prerequis/`, {});
  return isError || !data || typeof data !== 'object' ? {} : data;
};
